// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3Oi84","title":"AfterFrontImage_title__1HOcm"};